// Module
var code = "<div> <div class=\"rip-dialog-body-content\" ng-bind-html=\"message\"></div> <div class=\"rip-dialog-footer\"> <div class=\"rip-dialog-footer-buttons\"> <button ng-click=\"ok()\">{{ \"OK\" | i18n }}</button> <button ng-click=\"dismiss()\">{{ \"Cancel\" | i18n }}</button> </div> </div> </div> ";
// Exports
module.exports = code;